export enum InputType {
  INPUT = 'INPUT',
  NUMBER = 'NUMBER',
  VALUE = 'VALUE',
  BOOLEAN = 'BOOLEAN',
  TEXTAREA = 'TEXTAREA',
  EMAIL = 'EMAIL',
  PHONE_NUMBER = 'PHONE_NUMBER',
  DATE = 'DATE',
  COUNTRIES = 'COUNTRIES',
  STATES = 'STATES',
  SELECT = 'SELECT',
  MULTISELECT = 'MULTISELECT',
  SSN = 'SSN',
  EIN = 'EIN',
}

export type DynamicInputProps = {
  name: string;
  title?: string;
  type: InputType;
  placeholder?: string;
  values: string[];
  disabled?: boolean;
};
